import { useQuery } from '@tanstack/react-query';
import getSearchAutocomplete from './getSearchAutocomplete';
import queryKeys from '../reactQuery/queryKeys';

const useSearchAutocomplete = ({ term }: { term: string }) => {
  const res = useQuery({
    queryKey: queryKeys.searchAutocomplete(term),
    queryFn: ({ signal }) => getSearchAutocomplete({ term, signal }),
    keepPreviousData: true,
    staleTime: 1000 * Number(process.env.NEXT_PUBLIC_STALE_TIME_HOTEL_SEARCH ?? 0),
    enabled: !!term,
  });
  return res;
};

export default useSearchAutocomplete;
